import { accountIdFormat } from "@redotech/redo-account-id";
import { ToteNamingConfigSchema } from "@redotech/redo-fulfillment-wms-common/tote-naming-config";
import { locationIdFormat } from "@redotech/redo-inventory-id";
import {
  processingGroupIdFormat,
  sortingToteIdFormat,
} from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const ProcessingGroupSchema = z.object({
  id: processingGroupIdFormat.schema,
  name: z.string(),
  createdAt: z.date(),
  updatedAt: z.date(),
  merchantAccountIds: z.array(accountIdFormat.schema),
  sortingToteCount: z.number(),
  sortingToteIds: z.array(sortingToteIdFormat.schema),
  sortingToteLocationId: locationIdFormat.schema.nullable(),
  toteNamingConfig: ToteNamingConfigSchema.nullable(),
});

export const listProcessingGroups = {
  name: "listProcessingGroups" as const,
  input: z.object({}),
  output: z.object({ processingGroups: z.array(ProcessingGroupSchema) }),
};
